<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <TextField v-model="infos.title" label="Título"/>      
      </v-col>  

      <v-col cols="12" class="_pt">
        <TextArea v-model="infos.title" label="Descrição"/>      
      </v-col>    

      <v-col cols="12" class="_pt">
        <UploadImage v-model="info" keyValue="favicon"/>    
      </v-col>      
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TextField from '../../../_v2/ui/TextField.vue'
import TextArea from '../../../_v2/ui/TextArea.vue'
import UploadImage from '../../../_v2/utils/UploadImage.vue'

export default {
  components: { TextField, TextArea, UploadImage },
  computed: {
    ...mapGetters(["infos", "saveConfig"]),

    info: {
      get () { return this.infos },
      set (v) { 
        this.infos.favicon = v.favicon
      }
    }
  },

  methods: {
    save() {
      // this.saveConfig();
    },
  },
};
</script>

<style scoped>
* {
  font-family: Inter, sans-serif !important;
}
b {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #192b46;
}
</style>
